import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography';



export class DashboardRomTemplates extends Component {



    render() {
        const {
            mrFile,
            mqFile,
            nsFile,
            nwFile,
            mrFileName,
            mqFileName,
            nsFileName,
            nwFileName,
            monQualityCheckList,
            qcQualityCheckList,
            schedulePlan,
            //qualityChecklistFile,
            //draftTemplateforScheduleFile,
            //testOnDOCXClick,
            //testOnXLSXClick
        } = this.props

        return (
            <Card>
                <CardHeader title="ROM Templates" className='romis-card-header' />
                <CardContent>
                    <Typography variant="body1" gutterBottom>
                        Here is the downloadable versions of the ROM Templates;
                </Typography>

                    <Grid container className="mt-1" spacing={6} >
                        <Grid xs={3} item style={{ display: mrFile === null ? "none" : "block" }} >
                            <Button variant="outlined" color="primary" href={mrFile} download={mrFileName} fullWidth>
                                MR Download
                            </Button>
                        </Grid >
                        <Grid item xs={3} style={{ display: mqFile === null ? "none" : "block" }} >
                            <Button variant="outlined" color="primary" href={mqFile} download={mqFileName} fullWidth>
                                MQ Download
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{ display: nsFile === null ? "none" : "block" }} >
                            <Button variant="outlined" color="primary" href={nsFile} download={nsFileName} fullWidth>
                                {
                                    //NS Download
                                }
                                Monitoring Note for Supply Download
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{ display: nwFile === null ? "none" : "block" }} >
                            <Button variant="outlined" color="primary" href={nwFile} download={nwFileName} fullWidth>
                                {
                                    //NW Download
                                }
                                Monitoring Note for Works Download
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{ display: monQualityCheckList === null ? "none" : "block" }} >
                            <Button variant="outlined" color="primary" href={monQualityCheckList} download="" fullWidth>
                                Monitor Checklist
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{ display: qcQualityCheckList === null ? "none" : "block" }} >
                            <Button variant="outlined" color="primary" href={qcQualityCheckList} download="" fullWidth>
                                QC Checklist
                            </Button>
                        </Grid>
                        <Grid item xs={3} style={{ display: schedulePlan === null ? "none" : "block" }} >
                            <Button variant="outlined" color="primary" href={schedulePlan} download="MeetingSchedule.xlsx" fullWidth>
                                Meeting Schedule
                            </Button>
                        </Grid>

                    </Grid>

                    {
                        //<Grid container className="mt-1" spacing={6} >
                        //    <Grid xs={3} item>
                        //        <Button variant="outlined" color="primary" onClick={testOnDOCXClick} fullWidth>
                        //            Test DOCX
                        //</Button>
                        //    </Grid >
                        //    <Grid xs={3} item>
                        //        <Button variant="outlined" color="primary" onClick={testOnXLSXClick} fullWidth>
                        //            Test XLSX
                        //</Button>
                        //    </Grid >
                        //</Grid>
                    }

                </CardContent>
            </Card>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/DashboardRomTemplates.js